import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImages1Alt: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="images-1-alt, photos, pictures, shot"><path fillRule="evenodd" clipRule="evenodd" d="M20.25 3C20.6642 3 21 3.33579 21 3.75V20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25V3.75C3 3.33579 3.33579 3 3.75 3H20.25ZM8.53027 12.5303C8.23739 12.2375 7.76261 12.2375 7.46973 12.5303L4.5 15.5V19.5H15.5L8.53027 12.5303ZM15 6.5C13.6193 6.5 12.5 7.61929 12.5 9C12.5 10.3807 13.6193 11.5 15 11.5C16.3807 11.5 17.5 10.3807 17.5 9C17.5 7.61929 16.3807 6.5 15 6.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconImages1Alt;
